import { fromJS, List } from 'immutable';
import {
  GET_FILTERS,
  UPDATE_PARAMS,
  RESET_PARAMS,
  REMOVE_PARAM,
  FILTERS_RECEIVED,
} from './constants';
import { removeObjByAttribute } from '../../utils/common';

// The initial state of the App
export const initialState = fromJS({
  params: {},
  selectedParams: new List(),
  loading: true,
});

function searchReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PARAMS:
      let paramsList = state.getIn(['selectedParams']).toArray();
      paramsList = updateSelected(paramsList, action.param);
      return state.setIn(['selectedParams'], new List(paramsList));
    case FILTERS_RECEIVED:
      return state.set('params', action.filters).set('loading', false);
    case REMOVE_PARAM:
      let params = state.getIn(['selectedParams']).toArray();
      params = removeObjByAttribute(params, 'name', action.paramName);
      return state.setIn(['selectedParams'], new List(params));
    case RESET_PARAMS:
      return state.setIn(['selectedParams'], new List());
    case GET_FILTERS:
      return state.set('loading', true);
    default:
      return state;
  }
}

/**
 * Update selected parameters
 * @param selected
 * @param item
 * @returns {*[]}
 */
function updateSelected(selected, item) {
  const obj = { ...item };
  const params = removeObjByAttribute(selected, 'name', item.name);
  return [...params, obj];
}

export default searchReducer;
